// Tarih biçimlendirme yardımcıları — harici kütüphane olmadan native Intl ile.
// Kullanıcı listesi gibi yerlerde "2 saat önce" + tam tarih tooltip için kullanılır.

const REL_DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
]

/**
 * ISO tarih string'ini "2 saat önce", "dün", "3 ay önce" gibi göreli ifadeye çevirir.
 * Geçersiz/boş değerde boş string döner.
 */
export function formatRelativeTime(iso?: string | null, locale = 'tr'): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  let duration = (date.getTime() - Date.now()) / 1000 // saniye cinsinden (geçmiş → negatif)

  for (const division of REL_DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }
  return ''
}

/**
 * ISO tarih string'ini tam tarih + saat olarak biçimlendirir (tooltip için).
 * Örn: "17 Haziran 2026 23:39". Geçersiz/boş değerde boş string döner.
 */
export function formatFullDateTime(iso?: string | null, locale = 'tr-TR'): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Kısa tarih — "17 Haz 2026" gibi. Tabloda satır içi gösterim için.
 * Geçersiz/boş değerde boş string döner.
 */
export function formatShortDate(iso?: string | null, locale = 'tr-TR'): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}
